import moment from 'moment'
import { v4 as uuid } from 'uuid'
import CommonUtils from '@/utils/commonUtils'
import { CommandesService } from '../services/CommandesServicePoisson'
import { PlateauService } from '../services/PlateauService'
import { PlateauProductService } from '../services/PlateauProductService'
import { PlateauProductAnnexService } from '../services/PlateauProductAnnexService'


export const KEYBOARD_ACTION_PLATEAU_CONFIG = 'setCurrentCodePlateauConfig'
export const KEYBOARD_ACTION_PLATEAU_COPY_CONFIG = 'setCurrentCodePlateauCopyConfig'
export const KEYBOARD_ACTION_PLATEAU_CUSTOM_CONFIG = 'setCurrentCodePlateauCustomConfig'

export const KEYBOARD_VALIDATE_ACTION_PLATEAU_CONFIG = 'validateCurrentCodePlateauConfig'
export const KEYBOARD_VALIDATE_ACTION_PLATEAU_COPY_CONFIG = 'validateCurrentCodePlateauCopyConfig'
export const KEYBOARD_VALIDATE_ACTION_PLATEAU_CUSTOM_CONFIG = 'validateCurrentCodePlateauCustomConfig'

export const state = {
  currentCode: {},
  loadingConfig: false,
  loadingPlateauConfig: false,
  currentPlateau: '',
  plateaux: [],
  removedPlateaux: [],
  productsType: [],
  productAnnexList: [],
  productAnnex: [],
  plateauxProductAnnexList: [],
  plateauxProductList: [],
  conditionnementVente: [],
  modalNewPlateauConfig: false,
  modalRemovedPlateauConfig: false,
  modalRemovePlateauConfig: false,
  modalSeePlateauConfig: false,
  modalCopyPlateauConfig: false,
}

export const mutations = {
  [KEYBOARD_ACTION_PLATEAU_CONFIG](currentState, code) {
    currentState.plateau.currentCode = code
  },
  [KEYBOARD_ACTION_PLATEAU_COPY_CONFIG](currentState, code) {
    currentState.plateau.currentCode = code
  },
  [KEYBOARD_ACTION_PLATEAU_CUSTOM_CONFIG](currentState, code) {
    currentState.plateau.currentCode = code
  },
  setLoadingConfig(currentState, loadingConfig) {
    currentState.plateau.loadingConfig = loadingConfig
  },
  setLoadingPlateauConfig(currentState, loadingPlateauConfig) {
    currentState.plateau.loadingPlateauConfig = loadingPlateauConfig
  },
  setPlateauxConfig(currentState, plateaux) {
    currentState.plateau.plateaux = plateaux
  },
  setRemovedPlateauxConfig(currentState, removedPlateaux) {
    currentState.plateau.removedPlateaux = removedPlateaux
  },
  setProductsTypeConfig(currentState, productsType) {
    currentState.plateau.productsType = productsType
  },
  setPlateauxProductListConfig(currentState, plateauxProductList) {
    currentState.plateau.plateauxProductList = plateauxProductList
  },
  setPlateauxProductAnnexListConfig(currentState, plateauxProductAnnexList) {
    currentState.plateau.plateauxProductAnnexList = plateauxProductAnnexList
  },
  setModalPlateauConfig(currentState, modalNewPlateauConfig) {
    currentState.plateau.modalNewPlateauConfig = modalNewPlateauConfig
  },
  setModalRemovedPlateauConfig(currentState, modalRemovedPlateauConfig) {
    currentState.plateau.modalRemovedPlateauConfig = modalRemovedPlateauConfig
  },
  setModalRemovePlateauConfig(currentState, modalRemovePlateauConfig) {
    currentState.plateau.modalRemovePlateauConfig = modalRemovePlateauConfig
  },
  setModalSeePlateauConfig(currentState, modalSeePlateauConfig) {
    currentState.plateau.modalSeePlateauConfig = modalSeePlateauConfig
  },
  setModalCopyPlateauConfig(currentState, modalCopyPlateauConfig) {
    currentState.plateau.modalCopyPlateauConfig = modalCopyPlateauConfig
  },
  setProductAnnexList(currentState, productAnnexList) {
    currentState.plateau.productAnnexList = productAnnexList
  },
  setProductAnnex(currentState, productAnnex) {
    currentState.plateau.productAnnex = productAnnex
  },
  currentPlateau(currentState, currentPlateau) {
    currentState.plateau.currentPlateau = currentPlateau
  },
  setConditionnementVente(currentState, conditionnementVente) {
    currentState.plateau.conditionnementVente = conditionnementVente
  },
}

export const actions = {
  [KEYBOARD_ACTION_PLATEAU_CONFIG]({ commit }, code) {
    commit(KEYBOARD_ACTION_PLATEAU_CONFIG, code)
  },
  [KEYBOARD_ACTION_PLATEAU_COPY_CONFIG]({ commit }, code) {
    commit(KEYBOARD_ACTION_PLATEAU_COPY_CONFIG, code)
  },
  [KEYBOARD_ACTION_PLATEAU_CUSTOM_CONFIG]({ commit }, code) {
    commit(KEYBOARD_ACTION_PLATEAU_CUSTOM_CONFIG, code)
  },
  [KEYBOARD_VALIDATE_ACTION_PLATEAU_CONFIG]({ commit, rootState }, codeValue) {
    const foundProduct = rootState.plateau.plateauxProductList.map(product => {
      if (product.value._id === codeValue.uuid) {
        return ({ ...product, value: { ...product.value, code: codeValue.code } })
      }
      return product
    })
    commit('setPlateauxProductListConfig', foundProduct)
  },
  [KEYBOARD_VALIDATE_ACTION_PLATEAU_COPY_CONFIG]({ commit, rootState }, codeValue) {
    const foundProduct = rootState.plateau.plateauxProductList.map(product => {
      if (product.value._id === codeValue.uuid) {
        return ({
          ...product,
          value: {
            ...product.value, code: codeValue.code,
          },
        })
      }
      return product
    })
    commit('setPlateauxProductListConfig', foundProduct)
  },
  [KEYBOARD_VALIDATE_ACTION_PLATEAU_CUSTOM_CONFIG]({ commit, rootState }, codeValue) {
    const foundProduct = rootState.plateau.productsType.map(product => {
      if (product.value._id === codeValue.uuid) {
        return ({
          ...product,
          value: {
            ...product.value, code: codeValue.code, idCode: codeValue.code.idCode, idCodeMagasin: codeValue.code.idCodeMagasin,
          },
        })
      }
      return product
    })
    commit('setProductsTypeConfig', foundProduct)
  },
  setPlateauxProductEmptyListConfig({ commit }) {
    commit('setPlateauxProductListConfig', [])
  },
  setPlateauxProductAnnexEmptyListConfig({ commit }) {
    commit('setPlateauxProductAnnexListConfig', [])
  },
  setPlateauxProductListConfig({ commit }, products) {
    commit('setPlateauxProductListConfig', products)
  },
  setPlateauxProductAnnexListConfig({ commit }, productsAnnex) {
    commit('setPlateauxProductAnnexListConfig', productsAnnex)
  },
  getPlateauInfo({ commit, dispatch }, plateau) {
    dispatch('setCurrentPlateau', plateau)
    dispatch('getPlateauProductListConfig', { idPlateau: plateau.value.base_id || plateau.value._id, mode: !!plateau.value.base_id })
    dispatch('getPlateauProductAnnexListConfig', { idPlateau: plateau.value.base_id || plateau.value._id, mode: !!plateau.value.base_id })
  },
  setCurrentPlateau({ commit, dispatch }, plateau) {
    commit('currentPlateau', plateau)
  },
  upsertProductType({ commit, rootState }, product) {
    const productsTypeFiltered = rootState.plateau.productsType.concat(product)
    commit('setProductsTypeConfig', productsTypeFiltered)
  },
  addPlateauProductConfig({ commit, rootState }, product) {
    const products = rootState.plateau.plateauxProductList.concat(product)
    commit('setPlateauxProductListConfig', products)
  },
  addProductAnnex({ commit, rootState }, productAnnex) {
    const productsAnnexList = rootState.plateau.plateauxProductAnnexList.concat(productAnnex)
    commit('setPlateauxProductAnnexListConfig', productsAnnexList)
  },
  upsertPlateau({ commit, dispatch, rootState }, plateau) {
    const plateauProducts = CommonUtils.removeDictionnary(rootState.plateau.plateauxProductList)
    const plateauProductsAnnex = CommonUtils.removeDictionnary(rootState.plateau.plateauxProductAnnexList)
    return PlateauService.upsert(plateau)
      .then((plateauWithId) => Promise.all([
        ...plateauProducts.map((product, index) => PlateauProductService.save({
          ...product, idPlateau: plateauWithId._id, idCode: product.code.idCode, idDenomination: product.code.idDenomination, productOrder: index,
        })),
        ...plateauProductsAnnex.map((productAnnex, index) => PlateauProductAnnexService.save({ ...productAnnex, idPlateau: plateauWithId._id, productOrder: index })),
      ]).then(() => {
        commit('setModalPlateauConfig', false)
        commit('setModalCopyPlateauConfig', false)
        dispatch('loadDefaultPlateauData', false)
        dispatch('setPlateauxProductEmptyListConfig')
        dispatch('setPlateauxProductAnnexEmptyListConfig')

        this._vm.$toast.success('Votre plateau a bien été enregistré !')
      }).catch((err) => {
        this._vm.$toast.warning('Erreur pendant l\'enregistrement de votre plateau', err)
      }))
  },
  loadDefaultPlateauData({ commit, dispatch }) {
    commit('setLoadingConfig', true)
    return Promise.all([
      dispatch('getPlateauListConfig'),
      dispatch('getProductsTypeConfig'),
      dispatch('getProductAnnexList'),
      dispatch('getRemovedPlateaux'),
      dispatch('getConditionnementVente'),
    ]).then(() => {
      commit('setLoadingConfig', false)
    })
  },
  getPlateauListConfig({ commit }) {
    return PlateauService.getPlateaux()
      .then((plateaux) => {
        const plateauxEntries = plateaux.filter(plateau => !plateau.custom).sort((a, b) => moment(b.lastUpdate, 'YYYY-MM-DD HH:mm:ss').unix() - moment(a.lastUpdate, 'YYYY-MM-DD HH:mm:ss').unix()).map(plateau => CommonUtils.createDictionnaryEntry({ ...plateau, quantite: 0 }))
        commit('setPlateauxConfig', plateauxEntries)
      })
  },
  getProductAnnexList({ commit }) {
    return PlateauService.getProductAnnex()
      .then((productsAnnex) => {
        const productsAnnexEntries = productsAnnex.map(productAnnex => CommonUtils.createDictionnaryEntry({ ...productAnnex, quantite: 0, idProductAnnex: productAnnex._id }))
        commit('setProductAnnexList', productsAnnexEntries)
        commit('setProductAnnex', productsAnnexEntries)
      })
  },
  getRemovedPlateaux({ commit }) {
    return PlateauService.getRemovedPlateaux()
      .then((plateaux) => {
        const plateauxEntries = plateaux.filter(plateauWithDeleted => plateauWithDeleted.deleted && !plateauWithDeleted.custom).sort((a, b) => moment(b.lastUpdate, 'YYYY-MM-DD HH:mm:ss').unix() - moment(a.lastUpdate, 'YYYY-MM-DD HH:mm:ss').unix()).map(plateau => CommonUtils.createDictionnaryEntry({ ...plateau, quantite: 0 }))
        commit('setRemovedPlateauxConfig', plateauxEntries)
      })
  },
  getConditionnementVente({ commit }) {
    return CommandesService.getConditionnementVente()
      .then((conditionnementVente) => {
        commit('setConditionnementVente', conditionnementVente)
      })
  },
  getProductsTypeConfig({ commit }) {
    return PlateauService.getPlateauType()
      .then((productsType) => {
        commit('setProductsTypeConfig', productsType.sort((a, b) => a.productOrder - b.productOrder).map(item => CommonUtils.createDictionnaryEntry({
          ...item, code: { idCode: item.idCode, idCodeMagasin: item.idCodeMagasin }, defaultQuantite: item.quantite, product_id: item._id, deleted: CommonUtils.toBoolean(item.deleted),
        })))
      })
  },
  getPlateauProductListConfig({ commit, rootState }, plateau) {
    return PlateauProductService.getPlateauProducts(plateau.idPlateau)
      .then((plateauxProducts) => {
        const productList = plateauxProducts.map((product) => CommonUtils.createDictionnaryEntry({
          code: {
            idCode: product.idCode,
            idDenomination: product.idDenomination,
          },
          quantite: product.quantite,
          idConditionnementVente: product.idConditionnementVente,
          lastUpdate: product.lastUpdate,
          idPlateau: product.idPlateau,
          deleted: product.deleted,
          auxiliaire: product.auxiliaire,
          productOrder: product.productOrder,
          textConditionnementVente: rootState.plateau.conditionnementVente.find(cv => cv.idConditionnementVente === product.idConditionnementVente).nom,
          active: true,
          _id: plateau.mode ? uuid() : product._id,
          annex: false,
        })).sort((a, b) => a.value.productOrder - b.value.productOrder)
        commit('setPlateauxProductListConfig', productList)
      })
  },
  getPlateauProductAnnexListConfig({ commit, rootState }, plateau) {
    return PlateauProductAnnexService.getPlateauProductsAnnex(plateau.idPlateau)
      .then((plateauxProductsAnnex) => {
        const productAnnexList = plateauxProductsAnnex.map((productAnnex) => CommonUtils.createDictionnaryEntry({
          nom: rootState.plateau.productAnnex.filter(productAnnexBase => productAnnexBase.value._id === productAnnex.idProductAnnex)[0].value.nom,
          quantite: productAnnex.quantite,
          lastUpdate: productAnnex.lastUpdate,
          idPlateau: productAnnex.idPlateau,
          idProductAnnex: productAnnex.idProductAnnex,
          deleted: productAnnex.deleted,
          productOrder: productAnnex.productOrder,
          _id: plateau.mode ? uuid() : productAnnex._id,
          active: true,
          annex: true,
        })).sort((a, b) => a.value.productOrder - b.value.productOrder)
        commit('setPlateauxProductAnnexListConfig', productAnnexList)
        commit('setLoadingPlateauConfig', false)
      })
  },
  setModalPlateauConfig({ commit }, boolean) {
    commit('setModalPlateauConfig', boolean)
  },
  setModalRemovedPlateauConfig({ commit }, boolean) {
    commit('setModalRemovedPlateauConfig', boolean)
  },
  setModalRemovePlateauConfig({ commit }, boolean) {
    commit('setModalRemovePlateauConfig', boolean)
  },
  setModalSeePlateauConfig({ commit }, boolean) {
    commit('setModalSeePlateauConfig', boolean)
  },
  setModalCopyPlateauConfig({ commit }, boolean) {
    commit('setModalCopyPlateauConfig', boolean)
  },
  setLoadingPlateauConfig({ commit }, boolean) {
    commit('setLoadingPlateauConfig', boolean)
  },
  deletePlateauConfig({ commit, dispatch }, plateau) {
    return PlateauService.upsert({ ...plateau, deleted: true })
      .then(() => {
        dispatch('setModalRemovePlateauConfig', false)
        dispatch('loadDefaultPlateauData')
        this._vm.$toast.info('Plateau supprimé !')
      })
  },
  reassignPlateau({ commit, dispatch }, plateau) {
    return PlateauService.reassign(plateau)
      .then(() => {
        dispatch('setModalRemovedPlateauConfig', false)
        dispatch('loadDefaultPlateauData')
        this._vm.$toast.info('Plateau ajouté !')
      })
  },
  upsertProductTypeList({ commit }, productsType) {
    return Promise.all([...productsType.map(item => PlateauService.upsertType(item.value))])
      .then(() => {
        commit('setProductsTypeConfig', productsType)
      })
  },
}
export default {
  state,
  actions,
  mutations,
}
